const validateConfig = () => {
  const requiredVars = ['REACT_APP_RAZORPAY_KEY_ID'];
  const missing = requiredVars.filter((varName) => !process.env[varName]);

  if (missing.length > 0) {
    console.error('Missing required environment variables:', missing);
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }
};

validateConfig();

export const RAZORPAY_CONFIG = {
  KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID,

  COMPANY: {
    name: 'AarnaSignatures',
    description: 'Premium Fragrance Purchase',
    logo: '',
    website: 'https://aarnayours.com',
    support_email: 'support@aarnayours.com',
    support_phone: '+91-XXXXXXXXXX',
  },

  PAYMENT: {
    currency: 'INR',
    timeout: 300,
    retry_enabled: true,
    max_retry_count: 3,
    remember_customer: false,
    send_sms_hash: true,
    allow_rotation: true,
  },

  THEME: {
    color: '#667eea',
    backdrop_color: 'rgba(0,0,0,0.6)',
  },

  ORDER: {
    prefix: 'ORD',
    invoice_prefix: 'INV',
    receipt_prefix: 'RCP',
  },

  VALIDATION: {
    min_amount: 1,
    max_amount: 500000,
    payment_id_prefix: 'pay_',
    order_id_prefix: 'order_',
    min_payment_id_length: 15,
  },
};

export const generateOrderIds = () => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substr(2, 9);

  return {
    orderId: `${RAZORPAY_CONFIG.ORDER.prefix}_${timestamp}_${random}`,
    invoiceId: `${RAZORPAY_CONFIG.ORDER.invoice_prefix}-${timestamp}`,
    receiptId: `${RAZORPAY_CONFIG.ORDER.receipt_prefix}_${timestamp}`,
  };
};

export const validatePaymentAmount = (amount) => {
  const numAmount = parseFloat(amount);

  if (isNaN(numAmount) || numAmount <= 0) {
    throw new Error('Invalid payment amount');
  }

  if (numAmount < RAZORPAY_CONFIG.VALIDATION.min_amount) {
    throw new Error(`Minimum payment amount is ₹${RAZORPAY_CONFIG.VALIDATION.min_amount}`);
  }

  if (numAmount > RAZORPAY_CONFIG.VALIDATION.max_amount) {
    throw new Error(`Maximum payment amount is ₹${RAZORPAY_CONFIG.VALIDATION.max_amount.toLocaleString()}`);
  }

  return true;
};

export const validateRazorpayResponse = (response) => {
  const { razorpay_payment_id } = response;

  if (!razorpay_payment_id) {
    throw new Error('Missing payment ID');
  }

  if (!razorpay_payment_id.startsWith(RAZORPAY_CONFIG.VALIDATION.payment_id_prefix)) {
    throw new Error('Invalid payment ID format');
  }

  return true;
};

export default RAZORPAY_CONFIG;
